import styled from 'styled-components';

const SProfileWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export { SProfileWrapper };
